import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect, lazy, Suspense } from 'react'
import Header from './components/common/Header'
import Footer from './components/common/Footer'
import FloatingActionButton from './components/common/FloatingActionButton'
import DiwaliBanner from './components/common/DiwaliBanner'
import Home from './pages/Home'
import NotFound from './pages/NotFound'

const About = lazy(() => import('./pages/About'))
const Gallery = lazy(() => import('./pages/Gallery'))
const Menu = lazy(() => import('./pages/Menu'))
const Cupcakes = lazy(() => import('./pages/Cupcakes'))
const CakeBuilder = lazy(() => import('./pages/CakeBuilder'))
const Contact = lazy(() => import('./pages/Contact'))
const FAQ = lazy(() => import('./pages/FAQ'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const TaartBestellen = lazy(() => import('./pages/TaartBestellen'))
const Blog = lazy(() => import('./pages/Blog'))
const BlogPost = lazy(() => import('./pages/blog/BlogPost'))
const OrderView = lazy(() => import('./pages/OrderView'))
const AdminGate = lazy(() => import('./pages/admin/AdminGate'))

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function PublicLayout({ children }) {
  // The order page has its own bottom bar and WhatsApp step; the floating
  // button would sit on top of it.
  const { pathname } = useLocation()
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-20">
        <DiwaliBanner />
        <Suspense fallback={<div className="min-h-screen" />}>
          {children}
        </Suspense>
      </main>
      <Footer />
      {pathname !== '/cake-builder' && <FloatingActionButton />}
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public routes wrapped with Header + Footer */}
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
        <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
        <Route path="/menu" element={<PublicLayout><Menu /></PublicLayout>} />
        <Route path="/cupcakes" element={<PublicLayout><Cupcakes /></PublicLayout>} />
        <Route path="/cake-builder" element={<PublicLayout><CakeBuilder /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
        <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
        <Route path="/privacy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
        <Route path="/taart-bestellen-hoofddorp" element={<PublicLayout><TaartBestellen /></PublicLayout>} />
        <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
        <Route path="/blog/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
        <Route path="/order/:id" element={<PublicLayout><OrderView /></PublicLayout>} />

        {/* Admin route — no Header/Footer */}
        <Route path="/admin" element={<Suspense fallback={<div />}><AdminGate /></Suspense>} />

        {/* Anything else: noindex "not found" page */}
        <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
